export const financialRoutes = [
  {
    path: '/financeiro/historico-de-faturas',
    name: 'InvoiceHistory',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true,
      path: 'financial'
    },
    component: () => import(/* webpackChunkName: 'invoice-history-page' */ 'views/InvoiceHistoryPage')
  },
  {
    path: '/financeiro/ajustes-financeiros',
    name: 'FinancialAdjustments',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true,
      path: 'financial'
    },
    component: () => import(/* webpackChunkName: 'financial-adjustments-page' */ 'views/FinancialAdjustmentsPage')
  },
  {
    path: '/financeiro/recobranca-manual',
    name: 'ManualRetrieval',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true,
      path: 'financial'
    },
    component: () => import(/* webpackChunkName: 'manual-retrieval-page' */ 'views/ManualRetrievalPage')
  },
  {
    path: '/financeiro/bg2-imortar-nfe',
    name: 'ImportNfe',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true,
      path: 'financial'
    },
    component: () => import(/* webpackChunkName: 'import-nfe-page' */ 'views/ImportNfePage')
  },
  {
    path: '/financeiro/faturamento',
    name: 'Revenues',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true,
      path: 'financial'
    },
    component: () => import(/* webpackChunkName: 'revenues-page' */ 'views/RevenuesPage')
  }
]
